import axios, { AxiosError, AxiosPromise } from 'axios';

import { useState } from 'react';
import { getAPIUrl } from 'src/config';
import useEffectOnSome from 'src/CustomHooks/useEffectOnSome';
import IErrorDetails from 'src/ServerEntities/IErrorDetails';

export interface IRestApiRequestStatus<T> {
    data: T,
    loading: boolean,
    error: string
}

type HttpRequestVerb = "GET" | "PUT" | "POST" | "DELETE";

const makeApiRequest = (url: string, verb: HttpRequestVerb, body?: object, webToken?: string): AxiosPromise<any> => {
    switch (verb) {
        case "POST":
            return axios.post(
                getAPIUrl() + url,
                body,
                { headers: { Authorization: `Bearer ${webToken}` } }
            ).then(result => result)
                .catch(error => {
                    throw error;
                });

        case "GET":
            return axios.get(
                getAPIUrl() + url,
                { headers: { Authorization: `Bearer ${webToken}` } }
            ).then(result => result)
                .catch(error => {
                    throw error;
                });

        case "DELETE":
            return axios.post(
                getAPIUrl() + url,
                body,
                { headers: { Authorization: `Bearer ${webToken}` } }
            ).then(result => result)
                .catch(error => {
                    throw error;
                });

        case "PUT":
            return axios.put(
                getAPIUrl() + url,
                body,
                { headers: { Authorization: `Bearer ${webToken}` } }
            ).then(result => result)
                .catch(error => {
                    throw error;
                });

    }
};

const useRestAPI = (url: string, verb: HttpRequestVerb, body: object, webToken: string, refresh?: number | string, disabled?: boolean): IRestApiRequestStatus<any> => {
    const [data, setData] = useState(undefined as unknown as any);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined as unknown as string);

    // Similar to componentDidMount and componentDidUpdate:
    useEffectOnSome(() => {
        if ((refresh === undefined || (refresh !== 0)) && !disabled) {
            setLoading(true);

            makeApiRequest(url, verb, body, webToken).then(response => {
                setData(response.data);
                setLoading(false);
            }).catch((axiosError: AxiosError<IErrorDetails>) => {
                const errorText = axiosError.response && axiosError.response.data ? axiosError.response.data.message || axiosError.response.data.error : "No error message provided";
                setError(errorText);
                setLoading(false);
            });
        }
    }, [url, refresh], [body, verb, webToken]);

    return { data, loading, error };
};

export default useRestAPI;
